import React, { useState } from "react";

const API_URL = process.env.REACT_APP_API_URL;
console.log("API URL:", API_URL);
console.log(import.meta.env);
function App() {
  const [books, setBooks] = useState([]);
  const [bookId, setBookId] = useState("");
  const [singleBook, setSingleBook] = useState(null);

  const [newBook, setNewBook] = useState({
    id: "",
    title: "",
    author: "",
    price: "",
    category: "",
  });

  const headers = {
    "Content-Type": "application/json",
    "ngrok-skip-browser-warning": "true",
  };


  // GET ALL BOOKS
  const getAllBooks = async () => {
    try {
      const response = await fetch(`${API_URL}/books`, {
        method: "GET",
        headers,
      });

      if (!response.ok) {
        throw new Error(`HTTP Error: ${response.status}`);
      }

      const data = await response.json();
      setBooks(data);
    } catch (error) {
      console.error("Error fetching books:", error);
    }
  };

  // GET BOOK BY ID
  const getBookById = async () => {
    try {
      const response = await fetch(`${API_URL}/books/${bookId}`, {
        method: "GET",
        headers,
      });

      if (!response.ok) {
        throw new Error(`HTTP Error: ${response.status}`);
      }

      const data = await response.json();
      setSingleBook(data);
    } catch (error) {
      console.error("Error fetching book:", error);
    }
  };

  // CREATE BOOK
  const createBook = async () => {
    try {
      const response = await fetch(`${API_URL}/books/${newBook.id}`, {
        method: "POST",
        headers,
        body: JSON.stringify({
          id: Number(newBook.id),
          title: newBook.title,
          author: newBook.author,
          price: Number(newBook.price),
          category: newBook.category,
        }),
      });

      if (!response.ok) {
        throw new Error(`HTTP Error: ${response.status}`);
      }

      const data = await response.json();

      console.log("Created:", data);
      alert("Book Created Successfully");

      setNewBook({
        id: "",
        title: "",
        author: "",
        price: "",
        category: "",
      });
    } catch (error) {
      console.error("Error creating book:", error);
    }
  };

  



  return (
    <div style={{ padding: "20px", fontFamily: "Arial" }}>
      <h1>📚 Book Management App</h1>

      {/* Create Book */}
      <div
        style={{
          border: "1px solid #ccc",
          padding: "15px",
          marginBottom: "20px",
        }}
      >
        <h2>Create Book</h2>

        <input
          type="number"
          placeholder="Book ID"
          value={newBook.id}
          onChange={(e) =>
            setNewBook({ ...newBook, id: e.target.value })
          }
        />
        <br /><br />

        <input
          type="text"
          placeholder="Title"
          value={newBook.title}
          onChange={(e) =>
            setNewBook({ ...newBook, title: e.target.value })
          }
        />
        <br /><br />

        <input
          type="text"
          placeholder="Author"
          value={newBook.author}
          onChange={(e) =>
            setNewBook({ ...newBook, author: e.target.value })
          }
        />
        <br /><br />

        <input
          type="number"
          placeholder="Price"
          value={newBook.price}
          onChange={(e) =>
            setNewBook({ ...newBook, price: e.target.value })
          }
        />
        <br /><br />

        <input
          type="text"
          placeholder="Category"
          value={newBook.category}
          onChange={(e) =>
            setNewBook({ ...newBook, category: e.target.value })
          }
        />
        <br /><br />

        <button onClick={createBook}>Create Book</button>
      </div>

      {/* Get Single Book */}
      <div
        style={{
          border: "1px solid #ccc",
          padding: "15px",
          marginBottom: "20px",
        }}
      >
        <h2>Get Book By ID</h2>

        <input
          type="number"
          placeholder="Enter Book ID"
          value={bookId}
          onChange={(e) => setBookId(e.target.value)}
        />

        <button
          style={{ marginLeft: "10px" }}
          onClick={getBookById}
        >
          Fetch Book
        </button>

        {singleBook && (
          <div style={{ marginTop: "15px" }}>
            <h3>{singleBook.title}</h3>
            <p>ID: {singleBook.id}</p>
            <p>Author: {singleBook.author}</p>
            <p>Price: ₹{singleBook.price}</p>
            <p>Category: {singleBook.category}</p>
          </div>
        )}
      </div>

      {/* Get All Books */}
      <div
        style={{
          border: "1px solid #ccc",
          padding: "15px",
        }}
      >
        <h2>All Books</h2>

        <button onClick={getAllBooks}>Fetch All Books</button>

        {books.length > 0 &&
          books.map((book) => (
            <div
              key={book.id}
              style={{
                border: "1px solid #eee",
                padding: "10px",
                marginTop: "10px",
              }}
            >
              <h3>{book.title}</h3>
              <p>ID: {book.id}</p>
              <p>Author: {book.author}</p>
              <p>Price: ₹{book.price}</p>
              <p>Category: {book.category}</p>
            </div>
          ))}
      </div>
    </div>
  );
}

export default App; 

